import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { formatAmount } from "utils/helper";
import { Typography, Carousel, LoadingSkeleton } from "components";
import transactionVolumeImg from "assets/images/transaction-volume.png";
import totalAssignedTerminalImg from "assets/images/total-assigned-terminals.svg";
import totalTransactionValueImg from "assets/images/transaction-value-img.png";
import { getTransactionStatsBreakdown } from "redux/actions/transactionActions";
import { getTerminalActivity } from "redux/actions/dashboard/terminalDashboardActions";

const SummaryCards = () => {
  useEffect(() => {
    getTransactionStatsBreakdown();
    getTerminalActivity();

    //eslint-disable-next-line
  }, []);

  const { loading, value, volume } = useSelector(
    (state) => state.transactionsReducer.breakdown
  );

  const { terminalActivity } = useSelector(
    (state) => state.terminalDashboardReducer
  );

  const summaryCardDetails = [
    {
      label: "Transaction Volume",
      value: formatAmount(volume),
      loadingItem: loading,
      image: transactionVolumeImg,
    },
    {
      label: "Transaction Value",
      value: formatAmount(value),
      loadingItem: loading,
      image: totalTransactionValueImg,
    },
    // {
    //   label: "Total Amount Settled",
    //   value: "980,000",
    //   image: totalAmountSettledImg,
    // },
    {
      label: "Total Assigned Terminals",
      value: terminalActivity.data.totalTerminal || 0,
      loadingItem: terminalActivity.data.loading,
      image: totalAssignedTerminalImg,
    },
  ];

  return (
    <div style={{ maxWidth: "40rem" }}>
      <Carousel>
        {summaryCardDetails.map(
          ({ label, value, image, imgWidth, loadingItem }, key) =>
            loadingItem ? (
              <div className=" pt-3 px-2" key={key}>
                <LoadingSkeleton height="7rem" width="12rem" key={key} />
              </div>
            ) : (
              <div key={key} className="transaction-stats-card p-2">
                <Typography variant="caption1">{label}</Typography>
                <div className="main-detail mt-xl-1">
                  <Typography className="mt-1" state="primary">
                    {value}
                  </Typography>
                  <img
                    src={image}
                    alt={label}
                    style={{ width: imgWidth ? imgWidth : "" }}
                    className={imgWidth ? "min-image" : ""}
                  />
                </div>
              </div>
            )
        )}
      </Carousel>
    </div>
  );
};

export default SummaryCards;
